import getData from './axios';

/**
 * @param {*} params or data
 * @returns 消息待办接口
 */

// 获取消息
export function getMessageUser(data) {
  return getData({
    method: 'POST',
    url: '/platform/message/user',
    data: data
  });
}

// 已读消息
export function haveReadMessage(messageId) {
  return getData({
    method: 'GET',
    url: "platform/message/haveRead/".concat(messageId)
  });
}

// 刷新消息
export function refreshMessage(params) {
  return getData({
    method: 'GET',
    url: 'platform/message/refresh',
    params: params
  });
}

// 获取待办
export function getTodoUser(data) {
  return getData({
    method: 'POST',
    url: 'platform/todo/user',
    data: data
  });
}

// 刷新待办
export function refreshTodo(params) {
  return getData({
    method: 'GET',
    url: 'platform/todo/refresh',
    params: params
  });
}

// 获取系统数据
export function getSystemInnerList(params) {
  return getData({
    method: 'GET',
    url: 'platform/systemInner/list',
    params: params
  });
}

// 根据虚拟组获取真实字典
export function getVirtualGroupAccessReal(data) {
  return getData({
    method: 'POST',
    url: 'platform/virtualDict/virtualGroupAccessReal',
    data: data
  });
}